import { Controller } from "stimulus"
import Rails from "@rails/ujs"
import flatpickr from "flatpickr"
import moment from 'moment'

export default class extends Controller {
  static targets = ['calendar', 'slots', 'selectedSlot', 'selectedDate', 'button', 'unavailableNotice', 'addWaitingListBtn', 'waitlistForm']

  getSlots() {
    let employeeId = event.currentTarget.dataset.employeeId

    let employeeInput = document.getElementById('employee-id')
    employeeInput.value = employeeId

    document.querySelector('.loading-container').style.display = 'block'
    const calendar = flatpickr(this.calendarTarget, this.defaultCalendarConfig)

    //TODO: Reactor
    const slotsTarget = this.slotsTarget
    const buttonTarget = this.buttonTarget
    const unavailableNoticeTarget = this.unavailableNoticeTarget

    buttonTarget.style.display = 'none'
    unavailableNoticeTarget.style.display = 'none'

    while (slotsTarget.firstChild) {
      slotsTarget.removeChild(slotsTarget.firstChild);
    }

    Rails.ajax({
      url: `${this.url}&employee_id=${employeeId}`,
      type: "GET",
      success: function({availabilities, available_dates, fully_booked_dates}) {
        const maxDate = available_dates.length ? available_dates.slice(-1).join() : new Date

        calendar.set({
          maxDate: maxDate,
          enable: [...available_dates, ...fully_booked_dates]
        })

        calendar.config.onDayCreate.push(function(dObj, dStr, fp, dayElem) {
          const dateStr = moment(dayElem.dateObj).format('YYYY-MM-DD')

          if (fully_booked_dates.includes(dateStr)) {
            dayElem.classList.add('waitlist')
            dayElem.innerHTML += "<span class='fc-event'></span>";
          }
        })

        calendar.config.onChange.push(function(selectedDates, dateStr, instance) {
          slotsTarget.innerHTML = availabilities[dateStr]["html"]
          buttonTarget.style.display = 'block'
          buttonTarget.disabled = true

          if (availabilities[dateStr]['slots'].length == 0) {
            buttonTarget.style.display = 'none'
          }

          document.querySelector('.ba-selected-date').value = dateStr
        })

        if (available_dates.length) {
          const [firstAvailableDate] = [...available_dates, ...fully_booked_dates].sort()
          calendar.setDate(firstAvailableDate, true)

          // if (availabilities[firstAvailableDate]['slots'].length != 0) {
          //   // buttonTarget.style.display = 'block'
          // }
        } else {
          unavailableNoticeTarget.style.display = 'block'
        }

        document.querySelector('.loading-container').style.display = 'none'
      },
      error: function() {
        alert('Oh oh! Something went wrong, we are currently fixing this issue! Please refresh and try again in just a bit...')
      }
    })

    if (window.innerHeight < 750) {
      setTimeout(() => {
        this.scrollToCalendar()
      }, 0)
    }
  }

  scrollToCalendar() {
    const calendarWrapper = document.getElementById('calendar-wrapper')
    calendarWrapper.scrollIntoView({ behavior: 'smooth' })
  }

  selectTimeSlot() {
    this.slotsTarget.querySelectorAll('.time-slot').forEach((timeSlotElement) => {
      timeSlotElement.classList.remove('selected')
    })

    event.currentTarget.classList.add('selected')
    this.selectedSlotTarget.value = event.currentTarget.dataset.timeSlot
    this.verifyButtonEnabler()
  }

  verifyButtonEnabler() {
    this.buttonTarget.disabled = !this.hasSelectedTimeSlot
  }

  showWaitingListForm() {
    const selectedOptions = Array.from(document.querySelectorAll('.service-container--slim.selected'))
    const waitlist = document.getElementById('waitlist-service-options')

    if (waitlist) {
      waitlist.value = (selectedOptions?.length > 0 || false)
    }

    const el = document.getElementById("available-time-slots")
    this.addWaitingListBtnTarget.style.display = 'none'
    this.waitlistFormTarget.style.display = 'block'
    el.scrollIntoView({ behavior: 'smooth', block: "center" })
  }

  get hasSelectedTimeSlot() {
    return this.selectedSlotTarget.value.length
  }

  get selectedServiceItemId() {
    return document.querySelector('.service-container.selected').dataset.serviceId
  }

  get selectedServiceItemDuration() {
    const serviceOptions = document.getElementById('service-options')
    const selectedOptions = serviceOptions?.querySelector('.service-container.selected')

    let duration = parseInt(document.querySelector('.service-container.selected').dataset.duration)

    if (selectedOptions?.length) {
      duration += 0
    }

    return duration
  }

  get url() {
    return `${this.data.get('url')}?duration=${this.selectedServiceItemDuration}&service_item_id=${this.selectedServiceItemId}`
  }

  get defaultCalendarConfig() {
    return {
      inline: true,
      monthSelectorType: 'static',
      dateFormat: 'Y-m-d',
      minDate: 'today',
      maxDate: new Date,
      nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2.5" stroke="#ffffff" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="13" y1="18" x2="19" y2="12" /><line x1="13" y1="6" x2="19" y2="12" /></svg>',
      prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2.5" stroke="#ffffff" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="5" y1="12" x2="11" y2="18" /><line x1="5" y1="12" x2="11" y2="6" /></svg>',
      disable: [
        function(date) {
            return true
        }
      ]
    }
  }
}
